import * as React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import {
  SwitchBackground,
  SwitchBorder,
  SwitchCircle,
  SwitchContainer,
  SwitchFakeCheckbox,
  SwitchInput,
} from "src/components/shared/Switch/Switch.components";

interface Props {
  register?: UseFormRegisterReturn;
  onChange?: (value: boolean) => void;
  icon?: JSX.Element;
}

const Switch: React.FunctionComponent<Props> = ({
  register,
  onChange,
  icon,
}) => {
  const [isActive, setIsActive] = React.useState(false);

  const switchHandler = () => {
    setIsActive(prev => {
      if (onChange) {
        onChange(!prev);
      }
      return !prev;
    });
  };

  return (
    <SwitchContainer data-cy="switchContainer">
      <SwitchInput
        type="checkbox"
        onClick={switchHandler}
        {...(register && register)}
      />
      <SwitchFakeCheckbox>
        <SwitchBackground isActive={isActive} />
        <SwitchCircle isActive={isActive}>{icon}</SwitchCircle>
        <SwitchBorder />
      </SwitchFakeCheckbox>
    </SwitchContainer>
  );
};

export default Switch;
